import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullUser from "../fragments/fullUserV4"

const query = gql`
  mutation ActivateUser($userId: ID!) {
    activateUser(userId: $userId) {
      ...fullUser
    }
  }
  ${fullUser}
`

export const activateUserKey = getQueryNames(query)[0]

export default query
